"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawStructureEnum = void 0;
var DrawStructureEnum;
(function (DrawStructureEnum) {
    DrawStructureEnum["COMPASS"] = "COMPASS";
    DrawStructureEnum["CURTIS"] = "CURTIS_CONSOLATION";
    DrawStructureEnum["DOUBLE_ELIMINATION"] = "DOUBLE_ELIMINATION";
    DrawStructureEnum["SINGLE_ELIMINATION"] = "SINGLE_ELIMINATION";
    DrawStructureEnum["FEED_IN"] = "FEED_IN";
    DrawStructureEnum["FEED_IN_CHAMPIONSHIP"] = "FEED_IN_CHAMPIONSHIP";
    DrawStructureEnum["FEED_IN_CHAMPIONSHIP_TO_SF"] = "FEED_IN_CHAMPIONSHIP_TO_SF";
    DrawStructureEnum["FEED_IN_CHAMPIONSHIP_TO_QF"] = "FEED_IN_CHAMPIONSHIP_TO_QF";
    DrawStructureEnum["FEED_IN_CHAMPIONSHIP_TO_R16"] = "FEED_IN_CHAMPIONSHIP_TO_R16";
    DrawStructureEnum["FICQF"] = "FEED_IN_CHAMPIONSHIP_TO_QF";
    DrawStructureEnum["FICR16"] = "FEED_IN_CHAMPIONSHIP_TO_R16";
    DrawStructureEnum["FICSF"] = "FEED_IN_CHAMPIONSHIP_TO_SF";
    DrawStructureEnum["FIRST_MATCH_LOSER_CONSOLATION"] = "FIRST_MATCH_LOSER_CONSOLATION";
    DrawStructureEnum["FMLC"] = "FIRST_MATCH_LOSER_CONSOLATION";
    DrawStructureEnum["MFIC"] = "MODIFIED_FEED_IN_CHAMPIONSHIP";
    DrawStructureEnum["MODIFIED_FEED_IN_CHAMPIONSHIP"] = "MODIFIED_FEED_IN_CHAMPIONSHIP";
    DrawStructureEnum["OLYMPIC"] = "OLYMPIC";
    DrawStructureEnum["OTHER"] = "OTHER";
    DrawStructureEnum["PLAYOFF"] = "PLAYOFF";
    DrawStructureEnum["ROUND_ROBIN"] = "ROUND_ROBIN";
    DrawStructureEnum["ROUND_ROBIN_WITH_PLAYOFF"] = "ROUND_ROBIN_WITH_PLAYOFF";
    DrawStructureEnum["FRLC"] = "FIRST_ROUND_LOSER_CONSOLATION";
    DrawStructureEnum["FIRST_ROUND_LOSER_CONSOLATION"] = "FIRST_ROUND_LOSER_CONSOLATION";
    DrawStructureEnum["AD_HOC"] = "AD_HOC";
})(DrawStructureEnum || (exports.DrawStructureEnum = DrawStructureEnum = {}));
//# sourceMappingURL=draw_structure.js.map